import React, { useEffect, useState } from "react";
import { withLocalize } from "react-localize-redux";
import { change, Field, getFormValues } from 'redux-form';
import {
  StaffContainer,
  StaffContent,
  Category,
  TextAreaContainer,
  RemoveContainer,
  RemoveImg,
  Container,
  SelectContainer,
  NewOptionContainer,
  DefaultSupplierSelectContainer,
  NewCategorySelectContainer
} from "./StaffStyles";
import TextInput from "../inputs/TextInput";
import TextAreaInput from "../inputs/TextAreaInput";
import SelectInput from '../../components/inputs/SelectInput';
import Close from "../../assets/icons/close.svg";
import StaffCategory from "../staffCategory/StaffCategory";
import { GetExternalSuppliers, GetExternalSuppliersByCategory } from "../../infra/requests/ExternalSupplierCategoriesRequests";
import { useDispatch, useSelector } from "react-redux";

const Staff = ({ type, categories, categoriesKeys, removeElement, index, field, requiredError, toggleShowNew, showNewCategory, isProcessClosed, translate, activeLanguage }) => {
  const [defaultExternalSuppliersMap, setDefaultExternalSuppliersMap] = useState([]);
  const [defaultExternalSuppliers, setDefaultExternalSuppliers] = useState([]);
  const [selectedDefaultSupplier, setSelectedDefaultSupplier] = useState(null);
  const dispatch = useDispatch();
  const formValues = useSelector(state => getFormValues('section_form')(state));

  const handleCategoryChange = async (selectedCategory) => {
    const categoryIndex = categories?.[activeLanguage]?.indexOf(selectedCategory);
    const categoryKey = categoriesKeys[categoryIndex];
    if (categoryKey) {
      await loadDefaultExternalSuppliers(categoryKey);
      dispatch(change('section_form', `${field}.categoryTag`, categoryKey));
    } else {
      setDefaultExternalSuppliers([]);
      setDefaultExternalSuppliersMap([]);
      setSelectedDefaultSupplier(null);
      dispatch(change('section_form', `${field}.categoryTag`, ''));
      dispatch(change('section_form', `${field}.defaultSupplier`, null));
      dispatch(change('section_form', `${field}.name`, ''));
      dispatch(change('section_form', `${field}.email`, ''));
      dispatch(change('section_form', `${field}.contact`, ''));
    }
  };

  const handleDefaultSupplierChange = (selectedDefaultSupplier) => {
    const defaultSupplier = defaultExternalSuppliers.find(s => s?._id === selectedDefaultSupplier);
    if (defaultSupplier) {
      setSelectedDefaultSupplier(selectedDefaultSupplier);
      dispatch(change('section_form', `${field}.name`, defaultSupplier.name || ''));
      dispatch(change('section_form', `${field}.email`, defaultSupplier.email || ''));
      dispatch(change('section_form', `${field}.contact`, defaultSupplier.contact || ''));
    } else {
      setSelectedDefaultSupplier(null);
      dispatch(change('section_form', `${field}.defaultSupplier`, null));
      dispatch(change('section_form', `${field}.name`, ''));
      dispatch(change('section_form', `${field}.email`, ''));
      dispatch(change('section_form', `${field}.contact`, ''));
    }
  };

  const loadDefaultExternalSuppliers = async (categoryKey) => {
    setDefaultExternalSuppliers([]);
    setDefaultExternalSuppliersMap([]);
    setSelectedDefaultSupplier(null);

    let filters = {
      category: categoryKey,
      deleted: { $ne: true },
      isActive: true
    };

    const res = await GetExternalSuppliersByCategory(categoryKey);
    if (res?.success) {
      const suppliers = res?.data ? res?.data : [];
      if (!suppliers || suppliers?.length === 0) {
        if (formValues?.list?.[index]?.defaultSupplier) {
          dispatch(change('section_form', `${field}.defaultSupplier`, null));
          dispatch(change('section_form', `${field}.name`, ''));
          dispatch(change('section_form', `${field}.email`, ''));
          dispatch(change('section_form', `${field}.contact`, ''));
          setDefaultExternalSuppliers([]);
          setDefaultExternalSuppliersMap([]);
          setSelectedDefaultSupplier(null);
        }
        return;
      }

      const suppliersAux = suppliers.map(s => {
        return { key: s?._id, value: s?.name };
      });

      setDefaultExternalSuppliers(suppliers);
      setDefaultExternalSuppliersMap(suppliersAux);
    }
  };

  const isRequired = formValues?.list?.[index]?.isRequired;
  const withoutName = !formValues?.list?.[index]?.name || formValues?.list?.[index]?.name?.trim() === '';

  return (
    <StaffContainer type={type} isRequired={isRequired && withoutName}>
      <StaffContent>
        {
          type === 'filled' && !isProcessClosed && !isRequired &&
          <RemoveContainer>
            <RemoveImg src={Close} onClick={() => removeElement(index)} />
          </RemoveContainer>
        }
        <Category>{translate('ADD_EXTERNAL_STAFF')}</Category>
        <Container>
          <SelectContainer>
            <Field
              component={StaffCategory}
              name={`${field}.category`}
              categories={categories}
              showNew={showNewCategory}
              toggleShowNew={toggleShowNew}
              staffIndex={index}
              disabled={isProcessClosed || isRequired}
              onChange={(value) => handleCategoryChange(value)}
            />
          </SelectContainer>
          {defaultExternalSuppliersMap && defaultExternalSuppliersMap.length > 0 && <DefaultSupplierSelectContainer>
            <Field
              component={SelectInput}
              data={defaultExternalSuppliersMap}
              dataKey='key'
              dataLabel='value'
              translatable={false}
              name={`${field}.defaultSupplier`}
              allowClear={false}
              label={translate('EXTERNAL_SUPPLIER')}
              onChange={(value) => handleDefaultSupplierChange(value)}
            />
          </DefaultSupplierSelectContainer>}
          <NewCategorySelectContainer showNew={showNewCategory}>
            <Field
              name={`${field}.newCategory`}
              component={TextInput}
              placeholder={translate('ENTER_NAME')}
              type="text"
              requiredError={requiredError}
            />
          </NewCategorySelectContainer>
        </Container>
        <Field
          component={TextInput}
          name={`${field}.name`}
          type='text'
          label={translate('NAME_WD')}
          disabled={(isProcessClosed || selectedDefaultSupplier)}
        />
        <Field
          component={TextInput}
          name={`${field}.email`}
          type='text'
          label={translate('EMAIL')}
          disabled={isProcessClosed}
        />
        <Field
          component={TextInput}
          name={`${field}.contact`}
          type='text'
          label={translate('TELEPHONE')}
          disabled={isProcessClosed}
        />
        <TextAreaContainer>
          <Field
            component={TextAreaInput}
            name={`${field}.observations`}
            label={translate('OBSERVATIONS_WD')}
            placeholder={translate('MESSAGE_WD')}
            readOnly={isProcessClosed}
          />
        </TextAreaContainer>
      </StaffContent>
    </StaffContainer>
  );
}

export default withLocalize(Staff);